import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import AdminLayout from '../layouts/AdminLayout';
import { useAuth } from '../context/AuthContext';

// Public Pages
import HomePage from '../modules/home/HomePage';
import AboutPage from '../modules/about/AboutPage';
import CareersPage from '../modules/careers/CareersPage';
import NewsListPage from '../modules/news/NewsListPage';
import NewsDetailPage from '../modules/news/NewsDetailPage';
import TuThuocChoEmPage from '../modules/csr/TuThuocChoEmPage';
import ContactPage from '../modules/contact/ContactPage';
import WelcomeBioPage from '../modules/welcome/WelcomeBioPage';

// Admin Pages
import LoginPage from '../modules/admin/LoginPage';
import JobsManager from '../modules/admin/JobsManager';
import ApplicationsManager from '../modules/admin/ApplicationsManager';
import NewsManager from '../modules/admin/NewsManager';
import PartnersManager from '../modules/admin/PartnersManager';
import ImagesManager from '../modules/admin/ImagesManager';
import SettingsManager from '../modules/admin/SettingsManager';
import AccountManager from '../modules/admin/AccountManager';
import ExecutiveDashboard from '../modules/admin/ExecutiveDashboard';

function ProtectedAdminRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p className="lead">Đang kiểm tra quyền truy cập…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

export default function AppRoutes() {
  return (
    <Routes>
      {/* 1. Public Routes with MainLayout */}
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/gioi-thieu" element={<AboutPage />} />
        <Route path="/tuyen-dung" element={<CareersPage />} />
        <Route path="/tin-tuc" element={<NewsListPage />} />
        <Route path="/tin-tuc/:key" element={<NewsDetailPage />} />
        <Route path="/tu-thuoc-cho-em" element={<TuThuocChoEmPage />} />
        <Route path="/lien-he" element={<ContactPage />} />
      </Route>

      {/* 2. Welcome Bio Page (Standalone mobile layout) */}
      <Route path="/welcome" element={<WelcomeBioPage />} />

      {/* 3. Admin Auth */}
      <Route path="/admin/login" element={<LoginPage />} />

      {/* 4. Standalone Fullscreen Executive Dashboard (Protected) */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedAdminRoute>
            <ExecutiveDashboard />
          </ProtectedAdminRoute>
        }
      />

      {/* 5. Protected Admin Routes with AdminLayout */}
      <Route
        path="/admin"
        element={
          <ProtectedAdminRoute>
            <AdminLayout />
          </ProtectedAdminRoute>
        }
      >
        <Route index element={<Navigate to="/admin/jobs" replace />} />
        <Route path="jobs" element={<JobsManager />} />
        <Route path="applications" element={<ApplicationsManager />} />
        <Route path="news" element={<NewsManager />} />
        <Route path="partners" element={<PartnersManager />} />
        <Route path="images" element={<ImagesManager />} />
        <Route path="settings" element={<SettingsManager />} />
        <Route path="account" element={<AccountManager />} />
      </Route>

      {/* 5. Fallback 404 */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
